import { truncateHtml } from 'shared-widget-components/src/utils/truncateHtml';
import { OpeningTextWidgetState } from '../../../models/OpeningTextWidgetState';

export const useLangaugeContent = ({ props }: { props: OpeningTextWidgetState }) => {
  //@ts-ignore
  const languageCode = window.currentLanguageCode;

  const getLanguageContent = () => {
    if (props.titleNContent && props.titleNContent[languageCode]) {
      const languageConent = props.titleNContent[languageCode];
      return languageConent;
    }
    if (props.titleNContent) return props.titleNContent['hu'];
    return { title: '', description: '' };
  };

  const title = getLanguageContent().title;
  const truncatedTitle = truncateHtml(title, 40);

  const description = getLanguageContent().description;
  const truncatedDescription = truncateHtml(description, 500);

  return { truncatedTitle, truncatedDescription };
};
